export default __webpack_public_path__ + "static/media/juice-headline-desktop.2943a205.png";